import api from "./Api";
import { PORTS } from "../config/modulePort";
import axios from "axios";

const PICKLIST_URL = process.env.REACT_APP_PICKLIST_URL || "";
const Case = process.env.REACT_APP_CASE_URL || "";
const picklistAPI = api(PICKLIST_URL);
const CaseAPI = api(Case);

interface DoctorSchedulePayload {
  scheduleId: number;
  qmeDoctorContactId: number | null;
  scheduleType: string;
  scheduleMode: string;
  selectedMonths: string;
  startDate: string | null;
  endDate: string | null;
  selectedWeekDays: string;
  startTime: String;
  endTime: String;
  medicareProviderId: number | null;
  newMedicareProviderId: number | null;
  newEmailAddress: string;
  newPhoneNumber: string;
  newFaxNumber: string;
  nonAvailabilityReason: string;
}

export const getAssociatedHospitalList = async (
  stakeholderContactId: any
): Promise<any> => {
  try {
    const response = await picklistAPI.get(
      `/api/stakeholder/contact/medicarelist?contactUserId=${stakeholderContactId}`
    );
    const data = response.data.result;
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error("Unable to fetch the data. Please try again later.");
  }
};

export const getdHospitalList = async (searchString: string): Promise<any> => {
  try {
    const response = await picklistAPI.get(
      `/api/stakeholder/contact/medicare/search?searchString=${encodeURIComponent(
        searchString
      )}`
    );
    return response.data.result;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error("Unable to fetch the data. Please try again later.");
  }
};

export const addDoctorSchedule = async (
  payload: DoctorSchedulePayload
): Promise<any> => {
  try {
    const response = await CaseAPI.post(`/api/doctorschedule/add`, payload);
    return response.data;
  } catch (error) {
    console.error("Error adding doctor schedule:", error);
    throw new Error("Unable to add the schedule. Please try again later.");
  }
};
export const getAppointmentDetails = async (
  qmeScheduleId: number
): Promise<any> => {
  try {
    const response = await CaseAPI.get(
      `/api/appointment/details?qmeScheduleId=${qmeScheduleId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching appointment details:", error);
    throw new Error(
      "Unable to fetch appointment details. Please try again later."
    );
  }
};
export const updateDoctorSchedule = async (
  payload: DoctorSchedulePayload
): Promise<any> => {
  try {
    const response = await CaseAPI.post(`/api/doctorschedule/update`, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating doctor schedule:", error);
    throw new Error("Unable to update the schedule. Please try again later.");
  }
};

export const fetchMonthData = async (): Promise<any> => {
  try {
    const response = await picklistAPI.get(`/api/common/months`);
    if (response.data.isSuccess) {
      return response.data;
    } else {
      throw new Error("Failed to fetch month data");
    }
  } catch (error) {
    console.error("Error fetching month data:", error);
    throw new Error("Unable to fetch month data. Please try again later.");
  }
};
